import { useMemo } from 'react'

import EditIcon from '@mui/icons-material/Edit'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import { SelectProps } from 'components/Select'
import Table from 'components/Table'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'
import { formatUtcToBrasilia } from 'utils/formatDate'

export default function Labels() {
  const navigate = useNavigate()

  const { data } = useQuery<Label[]>(QUERY_KEYS.LABELS.LIST, () =>
    ApiService.Labels.getAll(),
  )

  useQuery<SelectProps['options']>(
    QUERY_KEYS.COMMERCIAL_UNITS.NAMES_AND_IDS,
    () =>
      ApiService.CommercialUnits.getAllNamesAndIds({
        fields: ['id', 'fantasy_name', 'document'],
        relations: [],
      }),
  )

  const columns = useMemo<GridColDef[]>(
    () => [
      { field: 'entity', headerName: 'Entidade', flex: 1 },
      { field: 'entity_translated', headerName: 'Nome', flex: 1 },
      {
        field: 'created_at',
        headerName: 'Criado em',
        flex: 1,
        valueGetter: ({ value }) => formatUtcToBrasilia(value as string),
      },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 80,
        sortable: false,
        renderCell: (params: GridRenderCellParams<Label>) => {
          return (
            <EditIcon
              onClick={() => {
                navigate(ROUTES.LABELS.EDIT(params.row.id))
              }}
            />
          )
        },
      },
    ],
    [navigate],
  )

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={false}>
        <Box>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ m: 1 }} variant="h4">
              Labels
            </Typography>

            <Box sx={{ m: 1 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  navigate(ROUTES.LABELS.CREATE)
                }}
              >
                Adicionar
              </Button>
            </Box>
          </Box>
        </Box>

        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Table rows={data} columns={columns} />
          </CardContent>
        </Card>
      </Container>
    </Box>
  )
}
